import { Injectable } from '@angular/core';

import { TExcelHeader } from '@core/domain/types';

@Injectable({
  providedIn: 'root',
})
export class ExcelFilesProvider {
  async generateExcel<T>(
    columns: TExcelHeader[],
    data: T[],
    fileName: string,
  ): Promise<void> {
    try {
      const Workbook = await this.getExcelJs();
      const saveAs = await this.getSaveFile();

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Sheet 1');

      worksheet.columns = columns;
      worksheet.addRows(data);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error al generar el archivo Excel:', error);
      throw new Error('No se pudo generar el reporte. Inténtelo de nuevo.');
    }
  }

  private async getExcelJs() {
    const exceljs = await import('exceljs');
    const Workbook = exceljs.Workbook || exceljs.default.Workbook;

    return Workbook;
  }

  private async getSaveFile() {
    const fileSaver = await import('file-saver');
    const saveAs = fileSaver.saveAs || fileSaver.default.saveAs;

    return saveAs;
  }
}
